export var IdAssetBundleNursery;
(function (IdAssetBundleNursery) {
    IdAssetBundleNursery["Nursery_0"] = "Nursery_0";
    IdAssetBundleNursery["Nursery_1"] = "Nursery_1";
    IdAssetBundleNursery["Nursery_2"] = "Nursery_2";
    IdAssetBundleNursery["Nursery_3"] = "Nursery_3";
    IdAssetBundleNursery["Nursery_4"] = "Nursery_4";
    IdAssetBundleNursery["Nursery_5"] = "Nursery_5";
    IdAssetBundleNursery["Nursery_6"] = "Nursery_6";
})(IdAssetBundleNursery || (IdAssetBundleNursery = {}));



//////////////////
// WEBPACK FOOTER
// ./src/assetBundles/outskirts/IdAssetBundleNursery.ts
// module id = 2141
// module chunks = 3